import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { useCallback } from "react";
import {
  relayReconnectRequested,
  selectRelayStatus,
} from "../services/relaySlice";

export interface UseRelayReconnectResult {
  /** Restart the relay handshake now, skipping any pending backoff. */
  reconnect: () => void;
  /** An attempt is in flight, so the button can say so. */
  isReconnecting: boolean;
}

/**
 * Retry affordance for a failed relay handshake.
 *
 * Goes through the store because {@link useRelaySession} is mounted once, in
 * `Authenticated`, while the failure is rendered several pages deeper.
 */
export const useRelayReconnect = (): UseRelayReconnectResult => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectRelayStatus);

  return {
    reconnect: useCallback(() => {
      dispatch(relayReconnectRequested());
    }, [dispatch]),
    isReconnecting: status === "connecting",
  };
};
